import { render, staticRenderFns } from "./ModificationDate.vue?vue&type=template&id=6646c084&scoped=true"
import script from "./ModificationDate.vue?vue&type=script&lang=js"
export * from "./ModificationDate.vue?vue&type=script&lang=js"
import style0 from "./ModificationDate.vue?vue&type=style&index=0&id=6646c084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646c084",
  null
  
)

export default component.exports